import { render, staticRenderFns } from "./AverbacaoSV.vue?vue&type=template&id=6f99408c&"
import script from "./AverbacaoSV.vue?vue&type=script&lang=js&"
export * from "./AverbacaoSV.vue?vue&type=script&lang=js&"
import style0 from "./AverbacaoSV.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports